import Drawer from "@mui/material/Drawer";
import { SxProps } from "@mui/material/styles";
import * as React from "react";

import useMobileLayout from "../../hooks/useMobileLayout";

type Props = {
    sx?: SxProps;
};

/**
 * Temporary mobile sidebar. Reads `isMenuOpen` from the mobile layout
 * context; closes itself via the context's setter.
 */
export default function MobileDrawer({ children, sx }: React.PropsWithChildren<Props>) {
    const { isMenuOpen, setIsMenuOpen } = useMobileLayout();

    return (
        <Drawer
            component="nav"
            variant="temporary"
            open={isMenuOpen}
            onClose={() => setIsMenuOpen(false)}
            slotProps={{ paper: { onClick: () => setIsMenuOpen(false) } }}
            sx={[
                { "& .MuiDrawer-paper": { backgroundColor: "background.default" } },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
        >
            {children}
        </Drawer>
    );
}
